import { useSearchPageQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
import getFeaturedBrands from "@faire/web-api--source/api/v3/search/products/featured-brands/post";
import { IGetFeaturedBrandsRequest } from "@faire/web-api--source/indigofair/data/IGetFeaturedBrandsRequest";
import { IGetFeaturedBrandsResponse } from "@faire/web-api--source/indigofair/data/IGetFeaturedBrandsResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const SEARCH_PAGE_FEATURED_BRANDS_QUERY_KEY = "SearchPageFeaturedBrands";

export const useSearchPageBrandTilesRelatedToSearch = (
  hookEnabled: boolean = true
) => {
  const searchPageData = useSearchPageQuery().data;
  const searchPageIsFetching = useSearchPageQuery().isFetching;

  const productTokens = useMemo(
    () =>
      searchPageData?.product_tiles
        ?.map((p) => p.product?.token)
        .filter((token) => !!token) as string[],
    [searchPageData?.product_tiles]
  );
  const irrelevantProductTokens = useMemo(
    () =>
      searchPageData?.irrelevant_product_tiles
        ?.map((p) => p.product?.token)
        .filter((token) => !!token) as string[],
    [searchPageData?.irrelevant_product_tiles]
  );

  const query = useQuery({
    queryKey: [
      SEARCH_PAGE_FEATURED_BRANDS_QUERY_KEY,
      productTokens,
      irrelevantProductTokens,
      searchPageData?.request_id,
    ],
    queryFn: async ({ signal }) => {
      if (!productTokens.length) {
        return IGetFeaturedBrandsResponse.build({});
      }

      return getFeaturedBrands(
        IGetFeaturedBrandsRequest.build({
          product_tokens: [
            ...(productTokens ?? []),
            ...(irrelevantProductTokens ?? []),
          ],
          request_id_from_parent_search_response:
            searchPageData?.request_id ?? "",
        }),
        { signal }
      );
    },
    enabled:
      productTokens &&
      productTokens.length > 0 &&
      !searchPageIsFetching &&
      hookEnabled,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  return {
    brandTilesRelatedToSearch: query.data?.brand_tiles,
    isFetching: query.isFetching,
    requestId: query.data?.request_id,
  };
};
